const stringInText = (text: string, findText: string): boolean => {
    if (!text) {
        return true;
    }
    const stringRowVal = String(text);
    const trimValue = findText.trim();
    if (!trimValue) {
        return true;
    }
    if (stringRowVal.indexOf(trimValue) === -1) {
        if (stringRowVal.toLocaleLowerCase().indexOf(trimValue) === -1) {
            if (
                stringRowVal
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLocaleLowerCase()
                    .indexOf(trimValue) === -1
            ) {
                return false;
            }
        }
    }
    return true;
};

export default stringInText;
